import { Card, List } from 'antd';
import styled from 'styled-components';

export const CardStyled = styled(Card)`
  cursor: grab;

  .ant-card-body {
    padding: 12px;
  }
`;

export const ListItemStyled = styled(List.Item)<{ $isColumn?: boolean; $isSmall?: boolean }>`
  &.ant-list-item {
    flex-direction: row;
    align-items: center;
    padding: 2px 0;
  }

  .ant-typography {
    font-family: InterRegular, sans-serif;
  }

  .listItemTitle {
    white-space: nowrap;
    margin-right: 10px;
  }
`;
